import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import api from '../../core/api';
import { catchError, map, mergeMap } from 'rxjs/internal/operators';
import { AjaxError, AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';
import RequestFailed from '../../core/events/RequestFailed';
import State from 'src/application/core/State';
import OrderDetailRequested from '../events/OrderDetailRequested';
import OrderDetailsReceived from '../events/OrderDetailsReceived';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(OrderDetailRequested.type),
        mergeMap((event: OrderDetailRequested) => {
            return backend.get(`${api()}users/${event.customerId}/orders/${event.orderId}/details`).pipe(
                map((ajaxResponse: AjaxResponse) => new OrderDetailsReceived(ajaxResponse.response)),
                catchError((e: AjaxError) => of(new RequestFailed(e.status)))
            );
        })
    );



// WEBPACK FOOTER //
// ./src/application/order/epic/orderDetailsGet.ts